import {createSlice} from "@reduxjs/toolkit";
import {User} from "../../models/user";

const initialState = {
    user: {} as User
};

export const sessionSlice = createSlice({
    name: "template",
    initialState,
    reducers: {
        resetSession: (state) => {
            state.user = initialState.user;
        },
        updateUser: (state, action) => {
            state.user = action.payload;
        }
    }
});

export const {
    resetSession,
    updateUser
} = sessionSlice.actions